<script>
import { EventCardElementMixin } from "%/dynamic-component-editor/standard-components/event-card/event-card-element-mixin";
import TextElement
  from "%/dynamic-component-editor/standard-elements/text-element/TextElement.vue";
import BrandedTextStyleOptions from "%/dynamic-component-editor/bundles/branded-text-style-options";

export default {
  name: "EventPrice",
  elementPanelSettings: {
    displayIcon: "bx:dollar",
    elementGroup: "eventElements",
    elementType: "element",
    displayName: "Event Price",
  },
  extends: TextElement,
  mixins: [EventCardElementMixin],
  optionBundles: [
    new BrandedTextStyleOptions({}, {
      "text-option": true,
    }),
  ],
  computed: {
    isEditable() {
      return false;
    },
    value() {
      return `$ ${this.entity.ticketPrice}`;
    },
  },
};
</script>
